export default __webpack_public_path__ + "static/pic04-148c0807acb6b0ee79497274017b1597.jpg";